import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appCompanyNavBar]',
})
export class CompanyNavBarDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
